import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid } from "@mui/x-data-grid";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

function TaxPolicyPage() {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });
  const columns = [];

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ p: 2, flexGrow: 1, display: "flex", flexDirection: "column" }}>
        {/* Khung tìm kiếm */}
        {/* <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <TextField
                label="Từ khóa"
                type="text"
                fullWidth
                value={keySearch || ""}
                onChange={(e) => setKeySearch(e.target.value)}
                size="small"
                sx={{ mr: 1, minWidth: 400 }}
              ></TextField>
              <Button
                variant="contained"
                color="primary"
                startIcon={<SearchIcon />}
                sx={{ width: 180 }}
                onClick={() => fetchIndustries(0, 20)}
              >
                Tìm kiếm
              </Button>
            </Grid>
          </Grid>
        </Paper> */}

        <Box sx={{ flexGrow: 1, width: "100%" }}>
          <DataGrid
            rows={policies}
            columns={columns}
            pageSizeOptions={[20, 50, 100]}
            disableRowSelectionOnClick
            loading={loading}
            getRowId={(row) => row.taxPolicyId}
            showCellVerticalBorder
            showColumnVerticalBorder
            onPaginationModelChange={(newModel) => {
              setPaginationModel(newModel);
            }}
            paginationModel={paginationModel}
            paginationMode="server"
            rowCount={policies.length}
            slots={{
              noRowsOverlay: () => (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  Không có chính sách nào được tìm thấy.
                </Box>
              ),
            }}
          />
        </Box>
      </Box>
    </LocalizationProvider>
  );
}
export default TaxPolicyPage;
